import React from "react";
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    overflow: 'hidden',
    '&:hover $image': {
      transform: 'scale(1.05)',
    },
  },
  image: {
    width: '100%',
    borderRadius: '5%',
    transition: 'transform 0.3s ease-in-out',
  },
}));

const MyCard = ({ title, content }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Grid container direction='column'>
          <Grid item md={12} sx={{border:'0.5px solig grey', borderRadius: '5%', overflow:'hidden'}}>
            <img
              src="https://reno.b-cdn.net/wp-content/uploads/2014/05/12-1-525x328.webp"
              alt="property_image"
              className={classes.image}
            />
          </Grid>
          <Grid item md={12} mt={1.5}>
            <Grid container spacing={0.5}>
              <Grid item md={12}>
                <Typography variant="body2" fontWeight='bold' color='#249fcf'>$ 20,000.00</Typography>
              </Grid>
              <Grid item md={12}>
                <Typography variant="body1" fontWeight='bold' color="#249fcf">Penthouse with 360 Infinity Pool</Typography>
              </Grid>
              <Grid item md={12}>
                <Typography variant='subtitle2'>Just steps away from QM2 express bus to Manhattan and local buses; only min ...</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const Latest = () => {
  const cards = [
    { title: 'Card 1', content: 'Content 1' },
    { title: 'Card 2', content: 'Content 2' },
    { title: 'Card 3', content: 'Content 3' },
    { title: 'Card 4', content: 'Content 4' },
    { title: 'Card 5', content: 'Content 5' },
    { title: 'Card 6', content: 'Content 6' },
    { title: 'Card 7', content: 'Content 7' },
    { title: 'Card 8', content: 'Content 8' },
  ];

  return (
    <>
        <Grid sx={{padding:'25px 0'}}>
            <Typography variant="h4">Latest Properties</Typography>
        </Grid>
        <Grid container spacing={2}>
          {cards.map((card, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
              <MyCard title={card.title} content={card.content} />
              </Grid>
          ))}
        </Grid>
    </>
  );
}

export default Latest;
